import { useCommitDiffDiscussions } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/stores/commit_discussions_store.js?vue3';
import { pinia } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/pinia/instance.js?vue3';

export const commitDiffDiscussionsStore = useCommitDiffDiscussions(pinia);
